import { useState } from "react";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Check, ChevronsUpDown, X } from "lucide-react";
import { cn } from "@/lib/utils";

export default function ManufacturerCombobox({
  value,
  onChange,
  options,
  placeholder = "Alle Hersteller",
  testid = "manufacturer-combobox",
}) {
  const [open, setOpen] = useState(false);

  const clear = (e) => {
    e.stopPropagation();
    onChange(null);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          data-testid={testid}
          className={cn(
            "w-[220px] justify-between bg-panel border-neutral-800 text-neutral-100 hover:bg-neutral-800/60 hover:text-neutral-100",
            !value && "text-neutral-400"
          )}
        >
          <span className="truncate">{value || placeholder}</span>
          {value ? (
            <X
              data-testid={`${testid}-clear`}
              className="ml-2 h-4 w-4 shrink-0 opacity-60 hover:opacity-100"
              onClick={clear}
            />
          ) : (
            <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-[280px] p-0 bg-panel border-neutral-800"
        align="start"
      >
        <Command className="bg-panel text-neutral-100">
          <CommandInput
            data-testid={`${testid}-search`}
            placeholder="Hersteller suchen…"
            className="border-neutral-800 text-neutral-100 placeholder:text-neutral-500"
          />
          <CommandList>
            <CommandEmpty className="text-neutral-500 text-sm py-4 text-center">
              Kein Treffer.
            </CommandEmpty>
            <CommandGroup className="max-h-[320px] overflow-auto">
              <CommandItem
                data-testid={`${testid}-opt-all`}
                value=""
                onSelect={() => {
                  onChange(null);
                  setOpen(false);
                }}
                className="text-neutral-300 aria-selected:bg-neutral-800"
              >
                <Check
                  className={cn(
                    "mr-2 h-4 w-4",
                    !value ? "opacity-100 text-[#D32222]" : "opacity-0"
                  )}
                />
                Alle Hersteller
              </CommandItem>
              {options.map((o) => (
                <CommandItem
                  key={o}
                  value={o}
                  data-testid={`${testid}-opt-${o}`}
                  onSelect={() => {
                    onChange(o);
                    setOpen(false);
                  }}
                  className="text-neutral-200 aria-selected:bg-neutral-800"
                >
                  <Check
                    className={cn(
                      "mr-2 h-4 w-4",
                      value === o ? "opacity-100 text-[#D32222]" : "opacity-0"
                    )}
                  />
                  {o}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
